export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#9DC36F',
    contrastText: '#FFFFFF',
    light: '#F1FAFE',
  },
  secondary: {
    main: '#0064C2',
    contrastText: '#002855',
  },
  text: {
    primary: '#141B22',
    light: '#273645',
    secondary: '#23262F',
    level2: '#64748B',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#0064C2',
    primary: '#43C2BD',
    secondary: '#9DC36F',
    paper: '#FFF',
    default: '#FFF',
    header: '#004485',
    footer: '#9DC36F',
    level2: '#f7f8fb',
    level1: '#F3F6F9',
    tableHead: '#9DC36F',
    tableSubhead: '#F7F7F7',
    arrow: '#10B7F2',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    disclaimer: "#101D29",
    description: "#F3F6F9"
  },
  verticalBar: {
    used: '#9DC36F',
    unused: '#ebf3e2',
    unlimited: '#C0C0C0',
  }
};
